import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _, { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { Acl } from 'modules/common/components/Acl';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import { ucwords } from 'helper';
import PropTypes from 'prop-types';
import Select from 'react-select';
import useFormValidator from 'useFormValidator';
import NumberFormat from 'react-number-format';
import Decimal from 'decimal.js';
import { MAX_LIMIT } from 'modules/common/constants';
import * as actions from '../../actions';
import * as c from '../../constant';
import BusinessActivity from './BusinessActivity';

const INIT_FORM_DATA = {
  base_line: '',
  veterinary_fee_id: '',
  calculation_details: {},
  area: '',
  floor_area: '',
  no_of_male_employees: '',
  no_of_female_employees: '',
  no_of_employees: '',
  no_of_employees_residing_manila: '',
  no_of_van: '',
  no_of_truck: '',
  no_of_motorcycle: '',
  details: {},
  activities: [],
};

function AssessApplication({
  data,
  assessRetirementRequest,
  updating,
  getBusinessNecessaryField,
  businessNecessaryField,
  getVetRegistrationList,
  vetRegistrationList,
  getCalculationDetailsByBarangay,
  handleGenerateSOA,
}) {
  const applicationStatusId = get('applicationStatusId');
  const setModal = useContext(ModalContext);
  const dataId = _.get(data, 'id');
  const retiredBusinessActivitiesList = _.get(
    data,
    'included.bplsRetirementActivities',
    []
  );
  const necessaryDetails = _.get(
    data,
    'included.bplsBusiness.attributes.details',
    {}
  );
  const permissions = getJson('permissions');
  const barangayCode = _.get(
    data,
    'included.bplsBusiness.attributes.barangay_code'
  );
  const retirementType = _.get(
    data,
    'included.bplsRetirements.attributes.is_full_retirement'
  );
  const [formDataCalculation, setFormDataCalculation] = useState({});
  const [formData, setFormData] = useState(INIT_FORM_DATA);
  const formActivities = _.get(formData, 'activities', []);
  const formDetails = _.get(formData, 'details', {});
  const filteredBusinessNecessaryField = businessNecessaryField.filter(
    (item) => !item.quantity_matrix
  );
  const filteredQuantityMatrix = businessNecessaryField.filter(
    item => _.isArray(item.quantity_matrix) && item.quantity_matrix.length > 0
  );
  const quantityMatrixValue = _.get(formDetails, 'quantity_matrix', {});

  const commonValidation = {
    base_line: 'required|number',
    area: 'required|number',
    floor_area: 'required|number',
    no_of_employees_residing_manila: 'required|number',
    no_of_male_employees: 'required|number',
    no_of_female_employees: 'required|number',
    no_of_van: 'required|number',
    no_of_truck: 'required|number',
    no_of_motorcycle: 'required|number',
  };

  const validateForm = useFormValidator(formData, commonValidation);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (!barangayCode || !dataId) return;
    getCalculationDetailsByBarangay(
      dataId,
      {
        main_office_barangay_code: barangayCode,
      },
      (cb) => {
        setFormDataCalculation((prev) => ({
          ...prev,
          ..._.get(cb, 'res', {}),
        }));
      }
    );
  }, [barangayCode, dataId]);

  useEffect(() => {
    if (!applicationStatusId) return;
    getBusinessNecessaryField({
      application_status_id: applicationStatusId,
    });
  }, [applicationStatusId]);

  useEffect(() => {
    getVetRegistrationList();
    const dataBusiness = _.get(data, 'included.bplsBusiness.attributes');
    setFormData((prev) => {
      const { quantity_matrix, ...businessDetail } = necessaryDetails;
      const multiplierQuantityMatrix = Object.values(quantity_matrix ?? {})
        .flatMap(item => _.isArray(item) ? item : [])
        .reduce((acc, { multiplier, value }) => {
          if (multiplier && !Number.isNaN(value)) {
            acc[multiplier] = +value;
          }
          return acc;
        }, {});

      const combinedDetails = {
        ...businessDetail,
        quantity_matrix: multiplierQuantityMatrix,
      };

      return {
        ...prev,
        ...dataBusiness,
        ...(!isEmpty(necessaryDetails) && {
          details: combinedDetails,
        }),
        override_amount: 0,
        activities: retiredBusinessActivitiesList.map((i) => {
          const attr = _.get(i, 'attributes', {});
          const activityId = _.get(i, 'id', '');
          return {
            ...attr,
            activity_id: activityId,
          };
        }),
      };
    });
  }, []);

  const requiredFields = Object.keys(
    _.get(data, 'included.bplsBusiness.attributes.details', {})
  ).reduce((acc, key) => {
    acc[key] = 'required';
    return acc;
  }, {});

  const validateFormBusinessNecessary = useFormValidator(
    formDetails,
    requiredFields
  );

  useEffect(() => {
    validateFormBusinessNecessary.validate();
    validateForm.validate();
  }, [JSON.stringify(formData)]);

  const onCheck = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked === true ? 1 : 0,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !validateForm.response.is_passed &&
      !validateFormBusinessNecessary.response.is_passed
    )
      return;

    const args = {
      ...formData,
      calculation_details: formDataCalculation,
    };

    assessRetirementRequest(_.get(data, 'id'), args, () => {
      handleGenerateSOA();
    });
  };

  const onChange = (key, value) => {
    setFormData((prev) => {
      return {
        ...prev,
        [key]: value,
      };
    });
  };

  const selectOptions = (list) => {
    const newList = [];

    if (_.isEmpty(list)) return false;

    list.map((listItem) => {
      return newList.push({
        label: ucwords(_.get(listItem, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, (x) => x.toUpperCase()),
        value: listItem.multiplier,
      });
    });
    return newList;
  };

  const onSelectDetails = (key) => (e) => {
    setFormData((prev) => ({
      ...prev,
      details: {
        ...prev.details,
        [key]: e.value,
      },
    }));
  };

  const onChangeNecessaryField = (type, key, value) => {
    if (type === 'multiplier') {
      setFormData((prev) => ({
        ...prev,
        details: {
          ...prev.details,
          [key]: value,
        },
      }));
    }

    if (type === 'quantity_matrix') {
      setFormData((prev) => ({
        ...prev,
        details: {
          ...prev.details,
          quantity_matrix: {
            ...prev.details.quantity_matrix,
            [key]: value,
          },
        },
      }));
    }
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const onChangeCalculationDetails = (e) => {
    const { name, value } = e;

    setFormDataCalculation((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // vet reg filter dropdown
  const listOption =
    vetRegistrationList.map((item) => ({
      label: _.get(item, 'attributes.veterinary_registration'),
      value: _.get(item, 'id'),
    })) || '';

  const addedData = {
    label: 'Select',
    value: '',
  };

  const sortOption = (listOption || []).concat([addedData]);
  const vetRegistrationListOption = _.orderBy(sortOption, ['value'], ['asc']);
  return (
    <Modal.Body>
      <form>
        <div className="container">
          <div className="row ml-auto text-primary font-weight-bold mb-2">
            Business Operation
          </div>
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="area" className="form-label mb-0">
                Business Area (sq.m):{' '}
                {validateForm.renderMessage('area')}
              </label>
              <NumberFormat
                name="area"
                id="area"
                allowLeadingZeros
                className="form-control"
                placeholder="_"
                displayType="input"
                thousandSeparator
                decimalScale={0}
                isNumericString
                prefix=""
                value={formData.area}
                disabled
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="floor_area" className="form-label mb-0">
                Total Floor Area (sq.m):{' '}
                {validateForm.renderMessage('floor_area')}
              </label>
              <NumberFormat
                name="floor_area"
                id="floor_area"
                allowLeadingZeros
                className="form-control"
                placeholder="_"
                displayType="input"
                thousandSeparator
                decimalScale={0}
                isNumericString
                prefix=""
                value={formData.floor_area}
                disabled
              />
            </div>
            <div className="col-6 form-group">
              <label
                htmlFor="no_of_employees_residing_manila"
                className="form-label mb-0"
              >
                Number of Employees residing within Area:{' '}
                {validateForm.renderMessage('no_of_employees_residing_manila')}
              </label>
              <NumberFormat
                name="no_of_employees_residing_manila"
                id="no_of_employees_residing_manila"
                allowLeadingZeros
                className="form-control"
                placeholder="_"
                displayType="input"
                thousandSeparator
                decimalScale={0}
                isNumericString
                prefix=""
                onValueChange={(values) => {
                  const { floatValue } = values;
                  onChange('no_of_employees_residing_manila', floatValue);
                }}
                value={formData.no_of_employees_residing_manila}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="no_of_male_employees" className="form-label mb-0">
                Total Number of Male Employees:{' '}
                {validateForm.renderMessage('no_of_male_employees')}
              </label>
              <NumberFormat
                name="no_of_male_employees"
                id="no_of_male_employees"
                allowLeadingZeros
                className="form-control"
                placeholder="_"
                displayType="input"
                thousandSeparator
                decimalScale={0}
                isNumericString
                prefix=""
                onValueChange={(values) => {
                  const { floatValue } = values;
                  onChange('no_of_male_employees', floatValue);
                }}
                value={formData.no_of_male_employees}
              />
            </div>
            <div className="col-6 form-group">
              <label
                htmlFor="no_of_female_employees"
                className="form-label mb-0"
              >
                Total Number of Female Employees:{' '}
                {validateForm.renderMessage('no_of_female_employees')}
              </label>
              <NumberFormat
                name="no_of_female_employees"
                id="no_of_female_employees"
                allowLeadingZeros
                className="form-control"
                placeholder="_"
                displayType="input"
                thousandSeparator
                decimalScale={0}
                isNumericString
                prefix=""
                onValueChange={(values) => {
                  const { floatValue } = values;
                  onChange('no_of_female_employees', floatValue);
                }}
                value={formData.no_of_female_employees}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="no_of_van" className="form-label mb-0">
                Number of Van Delivery Vehicle: (0 if not applicable):{' '}
                {validateForm.renderMessage('no_of_van')}
              </label>
              <NumberFormat
                name="no_of_van"
                id="no_of_van"
                allowLeadingZeros
                className="form-control"
                placeholder="_"
                displayType="input"
                thousandSeparator
                decimalScale={0}
                isNumericString
                prefix=""
                onValueChange={(values) => {
                  const { floatValue } = values;
                  onChange('no_of_van', floatValue);
                }}
                value={formData.no_of_van}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="no_of_truck" className="form-label mb-0">
                Number of Truck Delivery Vehicle: (0 if not applicable):{' '}
                {validateForm.renderMessage('no_of_truck')}
              </label>
              <NumberFormat
                name="no_of_truck"
                id="no_of_truck"
                allowLeadingZeros
                className="form-control"
                placeholder="_"
                displayType="input"
                thousandSeparator
                decimalScale={0}
                isNumericString
                prefix=""
                onValueChange={(values) => {
                  const { floatValue } = values;
                  onChange('no_of_truck', floatValue);
                }}
                value={formData.no_of_truck}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="no_of_motorcycle" className="form-label mb-0">
                Number of Motorcycle Delivery Vehicle: (0 if not applicable):{' '}
                {validateForm.renderMessage('no_of_motorcycle')}
              </label>
              <NumberFormat
                name="no_of_motorcycle"
                id="no_of_motorcycle"
                allowLeadingZeros
                className="form-control"
                placeholder="_"
                displayType="input"
                thousandSeparator
                decimalScale={0}
                isNumericString
                prefix=""
                onValueChange={(values) => {
                  const { floatValue } = values;
                  onChange('no_of_motorcycle', floatValue);
                }}
                value={formData.no_of_motorcycle}
              />
            </div>

            {filteredBusinessNecessaryField.map((item) => {
              const options = _.get(item, 'options');
              const multiplier = _.get(item, 'multiplier');
              const label = ucwords(multiplier ?? '').replace(/_/g, ' ');
              const validationIcon =
                validateFormBusinessNecessary.renderMessage(multiplier);

              if (options) {
                const optionsValue = selectOptions(options).find((option) => {
                  return (
                    _.get(formDetails, multiplier) === _.get(option, 'value')
                  );
                });

                return (
                  <div className="col-6 form-group" key={multiplier}>
                    <label htmlFor={multiplier} className="form-label mb-0">
                      {label} {validationIcon}
                    </label>
                    <Select
                      name={multiplier}
                      options={selectOptions(options)}
                      value={optionsValue || ''}
                      onChange={onSelectDetails(multiplier)}
                      components={{ IndicatorSeparator: () => null }}
                    />
                  </div>
                );
              }

              return (
                <div className="col-6 form-group" key={multiplier}>
                  <label htmlFor={multiplier} className="form-label mb-0">
                    {label} {validationIcon}
                  </label>
                  <NumberFormat
                    name={multiplier}
                    id={multiplier}
                    allowLeadingZeros
                    className="form-control"
                    placeholder="_"
                    displayType="input"
                    thousandSeparator
                    isNumericString
                    prefix=""
                    onValueChange={(values) => {
                      const { floatValue } = values;
                      onChangeNecessaryField(
                        'multiplier',
                        multiplier,
                        floatValue
                      );
                    }}
                    value={formDetails[multiplier]}
                  />
                </div>
              );
            })}
            {!_.isEmpty(filteredQuantityMatrix) ? (
              filteredQuantityMatrix.map((item) => {
                const multiplier = _.get(item, 'multiplier', '');

                return (
                  <React.Fragment>
                    <div className='form-group col-12 mb-0'>
                      <label className='form-label mb-0 text-capitalize'>
                        {multiplier}
                      </label>
                    </div>
                    <div className="w-100 border rounded-lg mx-3 mb-3">
                      <table className="table table-borderless table-sm table-striped table-hover mb-0">
                        <thead>
                          <tr className="form-group">
                            <td className="col-4 form-label text-center border-right">Unit</td>
                            <td className="col-4 form-label text-center border-right">Capacity</td>
                            <td className="col-4 form-label text-center">Number of Units</td>
                          </tr>
                        </thead>
                        <tbody>
                          {item.quantity_matrix.map((quantityMatrixItem) => {
                            const quantityMatrixMultiplier = _.get(quantityMatrixItem, 'multiplier');

                            return (
                              // eslint-disable-next-line react/no-array-index-key
                              <tr
                                key={quantityMatrixMultiplier}
                                className="border-top form-group"
                              >
                                <td className="col-4 text-left form-label border-right">
                                  {_.get(quantityMatrixItem, 'unit')}
                                </td>
                                <td className="col-4 text-left form-label border-right">
                                  {_.get(quantityMatrixItem, 'capacity')}
                                </td>
                                <td className="col-4 text-left form-label">
                                  <NumberFormat
                                    name={quantityMatrixMultiplier}
                                    id={quantityMatrixMultiplier}
                                    allowLeadingZeros
                                    className="form-control"
                                    onValueChange={(values) => {
                                      const { floatValue } = values;
                                      onChangeNecessaryField(
                                        'quantity_matrix',
                                        quantityMatrixMultiplier,
                                        floatValue
                                      );
                                    }}
                                    displayType="input"
                                    thousandSeparator
                                    isNumericString
                                    value={quantityMatrixValue[quantityMatrixMultiplier]}
                                  />
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </React.Fragment>
                )
              })
              
            ) : (
              ''
            )}
          </div>
          <div className="row ml-auto text-primary font-weight-bold mb-2">
            Calculation Details
          </div>
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Veterinary Registration:
              </label>
              <Select
                name="kind_of_ownership"
                placeholder="Select"
                onChange={handleOnChangeSelect('veterinary_fee_id')}
                options={vetRegistrationListOption}
                value={
                  vetRegistrationListOption.find((item) => {
                    return (
                      `${_.get(formData, 'veterinary_fee_id')}` ===
                      _.get(item, 'value')
                    );
                  }) || ''
                }
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="base_line" className="form-label mb-0">
                Base Line:
                {validateForm.renderMessage('base_line')}
              </label>
              <NumberFormat
                name="base_line"
                id="base_line"
                allowLeadingZeros
                className="form-control"
                placeholder="_"
                displayType="input"
                thousandSeparator
                isNumericString
                prefix=""
                value={formData.base_line}
                disabled
              />
            </div>
            {!isEmpty(formDataCalculation) &&
              Object.entries(formDataCalculation).map((item) => {
                return (
                  <div key={item[0]} className="col-6 form-group">
                    <label className="form-label mb-0">
                      {ucwords(item[0].replace(/_/g, ' '))}:
                    </label>
                    <NumberFormat
                      name={item[0]}
                      id={item[0]}
                      placeholder="0.00"
                      className="form-control"
                      onValueChange={(values) => {
                        const { value } = values;
                        const prop = {
                          name: item[0],
                          value,
                        };
                        onChangeCalculationDetails(prop);
                      }}
                      displayType="input"
                      decimalScale={2}
                      isNumericString
                      allowNegative
                      thousandSeparator
                      allowLeadingZeros
                      prefix="₱ "
                      value={_.get(formDataCalculation, item[0])}
                      isAllowed={(values) => {
                        const { value } = values;
                        if (!value) return true;
                        const val = new Decimal(value);
                        const max = new Decimal(MAX_LIMIT);
                        return value === undefined || val.lte(max);
                      }}
                    />
                  </div>
                );
              })}
          </div>
          <div className="row ml-auto text-primary font-weight-bold mb-2">
            Business Activities
          </div>
          <div className="row">
            <div className="d-flex col-6 form-group mb-2">
              <label htmlFor="last_name" className="form-label mb-0">
                Retirement Type:{' '}
              </label>
              <div className="mx-3">{retirementType ? 'Full' : 'Partial'}</div>
            </div>
          </div>
          <div className="row">
            {!_.isEmpty(formActivities) &&
              formActivities.map((item) => {
                const itemActivityId = _.get(item, 'activity_id', '');
                const itemName = _.get(item, 'name', '');
                const itemBusinessLineId = _.get(item, 'business_line_id', 0);
                return (
                  <div
                    className="col-sm-12 col-md-6"
                    key={itemActivityId}
                  >
                    <div className="border border-1 rounded p-3">
                      <div className='form-group'>
                        <label className="form-label">Line of Business:</label>
                        <div>{itemName}</div>
                      </div>
                      <BusinessActivity
                        data={item}
                        setFormData={setFormData}
                        activityId={itemActivityId}
                        businessLineId={itemBusinessLineId}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
          {Acl(permissions, ['OVERRIDE BPLS AMOUNT']) && (
            <div className="col-12 form-group">
              <label htmlFor="last_name" className="form-label">
                Override Minimum Amount &nbsp;
              </label>
              <input
                name="override_amount"
                type="checkbox"
                checked={_.get(formData, 'override_amount') || false}
                onChange={onCheck}
              />
            </div>
          )}
          <hr />
        </div>
        <div className="d-flex justify-content-center align-items-center mt-2">
          <button
            disabled={
              updating ||
              !validateForm.response.is_passed ||
              !validateFormBusinessNecessary.response.is_passed
            }
            type="button"
            onClick={handleSubmit}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-dark mr-2   "
          >
            <span className="font-weight-bold">Submit</span>
          </button>

          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AssessApplication.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  assessRetirementRequest: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  getBusinessNecessaryField: PropTypes.instanceOf(Function).isRequired,
  businessNecessaryField: PropTypes.instanceOf(Object).isRequired,
  getVetRegistrationList: PropTypes.instanceOf(Function).isRequired,
  vetRegistrationList: PropTypes.instanceOf(Object).isRequired,
  getCalculationDetailsByBarangay: PropTypes.instanceOf(Function).isRequired,
  handleGenerateSOA: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => {
  return {
    item: get(api, `${c.ITEM}.item`) || {},
    vetRegistrationList:
      _.get(api, `${c.GET_VET_REGISTRATION_LIST}.list`) || [],
    updating: api.loading.indexOf(c.UPDATE_DELINQUENT_CALCULATION_DETAIL) > -1,
    businessNecessaryField:
      _.get(api, `${c.GET_BUSINESS_NECESSARY_FIELD}.list`) || [],
  };
};

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AssessApplication);
